import { render } from "./RescoreDrawer.vue?vue&type=template&id=3ec05ac8&ts=true"
import script from "./RescoreDrawer.vue?vue&type=script&lang=ts"
export * from "./RescoreDrawer.vue?vue&type=script&lang=ts"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__